import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ROLE_LABELS } from "./navigation/menu";
import { initials } from "./navigation/menuUtils";

const BRAND_LOGO = `${process.env.PUBLIC_URL}/ldl-logo.png`;

const UserMenu =({ user, role, onSignOut }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (e) => !rootRef.current?.contains(e.target) && setOpen(false);
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
        rootRef.current?.querySelector("button")?.focus();
      }
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  const subtitle = user?.designation?.name || ROLE_LABELS[role] || "";

  return (
    <div className="erp-usermenu" ref={rootRef}>
      <button
        type="button"
        className="erp-usermenu__trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="erp-avatar" aria-hidden="true">
          {initials(user?.name)}
        </span>
        <span className="erp-usermenu__who">
          <strong>{user?.name || "Account"}</strong>
          {subtitle && <span>{subtitle}</span>}
        </span>
        <i className="fa fa-angle-down erp-usermenu__caret" aria-hidden="true" />
      </button>

      {open && (
        <div className="erp-usermenu__menu" role="menu">
          <div className="erp-usermenu__header">
            <strong>{user?.name}</strong>
            {user?.email && <span>{user.email}</span>}
            {role && <span className="erp-role-pill">{ROLE_LABELS[role] || role}</span>}
          </div>
          <Link to="/profile-edit" role="menuitem" className="erp-usermenu__item">
            <i className="fa fa-user-o" aria-hidden="true" /> My profile
          </Link>
          <Link to="/notification" role="menuitem" className="erp-usermenu__item">
            <i className="fa fa-bell-o" aria-hidden="true" /> Notifications
          </Link>
          <div className="erp-usermenu__divider" role="separator" />
          <button type="button" role="menuitem" className="erp-usermenu__item erp-usermenu__item--danger" onClick={onSignOut}>
            <i className="fa fa-sign-out" aria-hidden="true" /> Sign out
          </button>
        </div>
      )}
    </div>
  );
};

const Header = ({ user, role, active, notificationCount, navExpanded, onToggleNav, onSignOut }) => {
  const notificationLabel = notificationCount > 0 ? `Notifications, ${notificationCount} unread` : "Notifications";

  return (
    <header className="erp-topbar">
      <div className="erp-topbar__left">
        <button type="button" className="erp-icon-btn" aria-label="Toggle navigation" aria-expanded={navExpanded} onClick={onToggleNav}>
          <i className="fa fa-bars" aria-hidden="true" />
        </button>
        <Link to="/dashboard" className="erp-brand" aria-label="Limerick Distribution home">
          <img
            src={BRAND_LOGO}
            alt="Limerick Distribution Ltd."
          />
        </Link>

        {active && (
          <nav className="erp-breadcrumb" aria-label="Breadcrumb">
            <ol>
              {active.group && <li>{active.group.label}</li>}
              <li aria-current="page">{active.leaf.label}</li>
            </ol>
          </nav>
        )}
      </div>

      <div className="erp-topbar__right">
        <Link to="/notification" className="erp-icon-btn" aria-label={notificationLabel} title="Notifications">
          <i className="fa fa-bell-o" aria-hidden="true" />
          {notificationCount > 0 && <span className="erp-icon-btn__badge">{notificationCount > 99 ? "99+" : notificationCount}</span>}
        </Link>
        <span className="erp-topbar__divider" aria-hidden="true" />
        <UserMenu user={user} role={role} onSignOut={onSignOut} />
      </div>
    </header>
  );
};

export default Header;
